var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.4999 33.6666C8.29492 33.6666 0.833252 26.2049 0.833252 16.9999C0.833252 7.79492 8.29492 0.333252 17.4999 0.333252C26.7049 0.333252 34.1666 7.79492 34.1666 16.9999C34.1666 26.2049 26.7049 33.6666 17.4999 33.6666ZM15.8333 15.3333H9.16659V18.6666H15.8333V25.3333H19.1666V18.6666H25.8333V15.3333H19.1666V8.66659H15.8333V15.3333Z",
    fill: "#0F0F0F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon_add.473d4ee244d7e01ad49d9164664466b4.svg";
export { ForwardRef as ReactComponent };